import React, { useState } from 'react';
import { useCookies } from 'react-cookie';
import "../Styles/common.css";
import * as Comp from "../Common/CommonComponents";
import LoginModal from '../Components/Login/LoginModal';
import ForgetPassword from '../Components/Login/ForgetPassword';
import LoginResetPassword from "../Components/Login/LoginResetPassword";
import leftImage from '../Assets/calendarLeft.jpg';
import rightImage from '../Assets/claimRight.jpg';

const PAGE_NAME = "Login.js_";
const MODULE_ID = "LOGIN";

const Login = () => {
  const [cookies, setCookies, removeCookies] = useCookies([]);

  const [showLogin, setShowLogin] = useState(true);
  const [showReset, setShowReset] = useState(false);
  const [showForget, setShowForget] = useState(false);
  const [resetData, setResetData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingText, setLoadingText] = useState("Loading...");

  const images = importAll(require.context('../Assets', false, /\.(png|jpe?g|svg)$/));

  function importAll(r) {
    let images = {};
    r.keys().map((item) => { images[item.replace('./', '')] = r(item); });
    return images;
  }

  const showHideLoginModal = () => {
    setShowLogin(!showLogin);
    // setShowReset(!showReset);
    // setShowForget(!showForget);
  };

  const showHideResetModal = () => {
    setShowReset(!showReset);
    setShowLogin(!showLogin);
  };

  const showHideForgetModal = () => {
    setShowLogin(!showLogin);
    setShowForget(!showForget);
  };

  const onLoadingHandler = (load, text) => {
    setLoading(load);
    setLoadingText(text);
  };

  return (
    <>
      {/* <div style={{ backgroundColor: 'orange', height: '100vh', width: '100%' }}>
      </div> */}
      <div style={{
        display: 'flex',
        width: '100%',
        height: '100vh',
      }}>
        <div style={{
          flex: 1,
          backgroundImage: `url(${leftImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}></div>

        <div style={{
          flex: 1,
          backgroundImage: `url(${rightImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}></div>
      </div>

      <LoginModal
        page={PAGE_NAME}
        module={MODULE_ID}
        showHide={showLogin}
        onHide={showHideLoginModal}
        onLoading={onLoadingHandler}
        setCookies={setCookies}
        removeCookies={removeCookies}
        setResetData={setResetData}
        showHideResetModal={showHideResetModal}
        showHideForgetModal={showHideForgetModal}
        images={images}
      />

      <ForgetPassword
        page={PAGE_NAME}
        module={MODULE_ID}
        showHide={showForget}
        onHide={showHideForgetModal}
        onLoading={onLoadingHandler}
        setCookies={setCookies}
        removeCookies={removeCookies}
        showHideLoginModal={showHideLoginModal}
      />

      <LoginResetPassword
        page={PAGE_NAME}
        module={MODULE_ID}
        showHide={showReset}
        editData={resetData}
        onHide={showHideResetModal}
        onLoading={onLoadingHandler}
        setCookies={setCookies}
        removeCookies={removeCookies}
        showHideLoginModal={showHideLoginModal}
      />

      {loading && <Comp.Loading>{loadingText}</Comp.Loading>}
      <Comp.AlertPopup />
    </>
  );
}

export default Login;
